import React, { useEffect, useState } from 'react';

// label, IANA time zone. The first row is shown large, the second small.
// Each row runs from the earliest clock time to the latest (west to east).
export const MAIN_ZONES = [
  { label: 'Western Time', zone: 'America/Los_Angeles' },
  { label: 'Texas Time', zone: 'America/Chicago' },
  { label: 'Atlantic Time', zone: 'America/New_York' }
];
export const WORLD_ZONES = [
  { label: 'GMT', zone: 'UTC' },
  { label: 'Berlin', zone: 'Europe/Berlin' },
  { label: 'Jerusalem', zone: 'Asia/Jerusalem' },
  { label: 'Moscow', zone: 'Europe/Moscow' },
  { label: 'Delhi', zone: 'Asia/Kolkata' },
  { label: 'Beijing', zone: 'Asia/Shanghai' },
  { label: 'Tokyo', zone: 'Asia/Tokyo' },
  { label: 'Sydney', zone: 'Australia/Sydney' },
  { label: 'Auckland', zone: 'Pacific/Auckland' }
];

// military is 24-hour (14:05:09), civilian is 12-hour with AM/PM; no zone means the visitor's own
export const formatTime = (date, zone, military = true) =>
  new Intl.DateTimeFormat('en-US', {
    timeZone: zone,
    hour: military ? '2-digit' : 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: military ? 'h23' : 'h12'
  }).format(date);

function WorldClock({ military, onChangeMilitary }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const row = (zones, className) => (
    <ul className={className}>
      {zones.map(({ label, zone }) => (
        <li key={zone}>
          <span className="fm-clock-label">{label}</span>
          <span className="fm-clock-time">{formatTime(now, zone, military)}</span>
        </li>
      ))}
    </ul>
  );

  return (
    <div className="fm-clock" role="timer" aria-label="World clock">
      <div className="fm-clock-toggle" role="group" aria-label="Time format">
        <button type="button" aria-pressed={military} onClick={() => onChangeMilitary(true)}>military</button>
        <button type="button" aria-pressed={!military} onClick={() => onChangeMilitary(false)}>civilian</button>
      </div>
      {row(MAIN_ZONES, 'fm-clock-main')}
      <ul className="fm-clock-world">
        {WORLD_ZONES.map(({ label, zone }) => (
          <li key={zone}>
            <span className="fm-clock-label">{label}</span>
            <span className="fm-clock-time">{formatTime(now, zone, military)}</span>
          </li>
        ))}
        {/* the visitor's own time: shown here on narrow screens, where it fills the last slot of the grid, and in the Now Playing bar on wide ones */}
        <li className="fm-clock-local">
          <span className="fm-clock-label">Your time</span>
          <span className="fm-clock-time">{formatTime(now, undefined, military)}</span>
        </li>
      </ul>
    </div>
  );
}

export default WorldClock;
